export default "__VITE_ASSET__CYV_PoyL__"